var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding-top padding-bottom content"},[_c('div',{staticClass:"flex"},[_c('h1',[_vm._v("Edit discount #"+_vm._s(_vm.getId()))]),_vm._m(0)]),_c('DiscountEditor',{staticClass:"large-margin-top",attrs:{"id":_vm.getId()}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"margin-left"},[_c('a',{attrs:{"href":"/#/discounts"}},[_c('button',[_vm._v("« Back")])])])
}]

export { render, staticRenderFns }